import React, { useState } from "react";

export default function BazAiTextArea() {
  const [height, setHeight] = useState(50);
  const [comment, setComment] = useState("");
  return (
    <div className="flex items-center relative py-5 px-4">
      <div className="flex items-center w-[calc(100%)]">
        <div className="flex items-center relative w-full flex-1 ml-2 baz-ai-text-input">
          <textarea
            style={{
              height: `${height}px`,
              overflow: height === 120 ? "auto" : "hidden",
              resize: "none",
              width: "100%",
              padding: "10px",
              paddingTop: "15px",
              boxSizing: "border-box",
              paddingRight: 35,
              borderRadius: 15,
            }}
            onChange={(e) => {
              setComment(e.target.value);
            }}
            value={comment}
            type="text"
            placeholder="Enter your question"
            className="gpt-text-area py-3.5 pr-10 px-3 appearance-none block mr-1 border leading-tight focus:outline-1 bg-white focus:bg-white text-14 w-full"
          />
          <p className="absolute right-[14px] bottom-[12px]">
            <img
              className="w-7 h-7"
              src="/assets/images/bazai/send.png"
              alt="icon"
            />
          </p>
        </div>
      </div>
    </div>
  );
}
